<template>
<div class="mobilenavbar-container" :class="{'high-contrast': highContrast || scrolled}">
    <vs-button transparent @click="navigate('Blog')" :class="{'active': active == 'Blog'}">
        <img class="inactive" src="../assets/icons/discover_gray.png" />
        <img class="active" src="../assets/icons/discover.png" />
    </vs-button>
    <vs-button transparent @click="navigate('Viaggi')" :class="{'active': active == 'Viaggi'}">
        <img class="inactive" src="../assets/icons/menu/trips.png" />
        <img class="active" src="../assets/icons/menu/trips_active.png" />
    </vs-button>

    <vs-button circle class="center-action" style="height: 58px; width: 58px; border-radius: 100px; margin-top: -22px;" @click="navigate('Esplora')" :class="{'active': active == 'Esplora'}">
        <img src="../assets/icons/menu/explore_white.png" />
    </vs-button>
    <vs-button transparent @click="navigate('Preferiti')" :class="{'active': active == 'Preferiti'}">
        <img class="inactive" src="../assets/icons/menu/m_favourites.png" />
        <img class="active" src="../assets/icons/menu/m_favourites_active.png" />
    </vs-button>

    <vs-button transparent @click="navigate('Profilo')" :class="{'active': active == 'Profilo'}">
       
        <vs-avatar badge-color="danger" badge-position="top-right" size="40" square>
            <img class="inactive" src="../assets/icons/menu/profile.png" />
            <img class="active" src="../assets/icons/menu/profile_active.png" />


            <template #badge v-if="$parent.notificationsCount > 0">
            {{ $parent.notificationsCount > 10 ? '10+' : $parent.notificationsCount }}
            </template>
        </vs-avatar>
    </vs-button>
</div>
</template>

<script>
export default {
    name: 'mobileNavbar',
    props: {
        component: Object,
        user: Object,
        highContrast: {
            type: Boolean,
            default: false
        }
    },
    data(){
        return {
            active: '',
            scrolled: false
        }
    },
    methods: {
        navigate(d){
            this.$router.push({
                name: d
            })
            this.active = d;
        },
        onScroll(){
            this.scrolled = window.scrollY > 12;
        }
    },
    mounted() {
        // Set the initial active route based on the current route
        this.active = this.$route.meta.menu || '';
        // Elevate visibility on scroll
        window.addEventListener('scroll', this.onScroll, { passive: true });
        this.onScroll();
    },
    components: {},
    beforeDestroy(){
        window.removeEventListener('scroll', this.onScroll);
    },
    watch: {
        '$route'(n) {
            this.active = n.meta.menu;
        },
    }
}
</script>

<style scoped>
.mobilenavbar-container {
    background: rgba(255, 255, 255, 0.70);
    -webkit-backdrop-filter: saturate(150%) blur(14px);
    backdrop-filter: saturate(150%) blur(14px);
    border: 1px solid rgba(255, 255, 255, 0.35);
    height: 60px;
    position: fixed;
    bottom: 12px;
    left: 25px;
    right: 25px;
    z-index: 3000;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 4px 6px;
    box-shadow: 0 10px 30px rgba(16, 24, 40, 0.18);
    width: auto;
    border-radius: 24px;
}

.tourial-app.tourial-native .mobilenavbar-container {
    bottom: max(12px, calc(6px + env(safe-area-inset-bottom))) !important;
    padding-left: 16px!important;
    padding-right: 16px!important;
    box-sizing: border-box;
}
.mobilenavbar-container.high-contrast {
    background: rgba(255, 255, 255, 0.90);
    border-color: rgba(0,0,0,0.08);
    box-shadow: 0 14px 38px rgba(16, 24, 40, 0.25);
}
.mobilenavbar-container.high-contrast .vs-button.active img.active {
    filter: invert(52%) sepia(86%) saturate(746%) hue-rotate(352deg) brightness(98%) contrast(103%);
}
.mobilenavbar-container.high-contrast .vs-button:not(.active) img.active {
    /* never show the colored icon for inactive tabs */
    display: none !important;
    filter: none !important;
    opacity: 0 !important;
}
.mobilenavbar-container.high-contrast .vs-button:not(.active) img.inactive {
    /* enforce neutral look for inactive icons in high-contrast mode */
    filter: grayscale(1) saturate(0) brightness(1.05) contrast(0.9) hue-rotate(0deg) !important;
    opacity: 0.98 !important;
}
</style>

<style>
.mobilenavbar-container .vs-button img.active {
    /* hide colored icon by default; show it only for the active tab */
    display: none;
    transition: filter .2s ease, transform .2s ease, opacity .2s ease;
}

.mobilenavbar-container .vs-button.active img.inactive {
    display: none !important;
}
.mobilenavbar-container .vs-button.active img.active {
    /* active = orange tint */
    display: block !important;
    filter: invert(52%) sepia(86%) saturate(746%) hue-rotate(352deg) brightness(98%) contrast(103%);
    transform: scale(1.02);
    opacity: 1;
}

.mobilenavbar-container .vs-button img.inactive {
    /* show neutral/gray icon by default for all tabs */
    display: block !important;
    opacity: 0.95;
    filter: grayscale(1) saturate(0) brightness(1.05) contrast(0.9) hue-rotate(0deg);
    transition: filter .2s ease, transform .2s ease, opacity .2s ease;
}

.mobilenavbar-container .vs-button img {
    height: 24px;
    width: auto;

}

.mobilenavbar-container .vs-avatar {
    background: transparent!important;
    box-shadow: none!important;
}

.mobilenavbar-container .vs-avatar-content:hover img {
    transform: unset!important;
}

/* Center action button: keep icon white in both states */
.mobilenavbar-container .vs-button.center-action img {
    filter: brightness(0) invert(1) !important;
}
.mobilenavbar-container .vs-button.center-action.active img {
    filter: brightness(0) invert(1) !important;
}

/* Micro-interactions: subtle motion and feedback */
.mobilenavbar-container {
    transition: box-shadow .25s ease, background-color .25s ease, backdrop-filter .25s ease;
}

/* Buttons: hover/tap feedback */
.mobilenavbar-container .vs-button {
    transition: transform .15s ease, box-shadow .25s ease, background-color .2s ease, border-color .2s ease, filter .2s ease;
    will-change: transform;
}
.mobilenavbar-container .vs-button:active {
    transform: scale(.96);
}

/* Active tab slight emphasis */
.mobilenavbar-container .vs-button.active .active {
    filter: invert(52%) sepia(86%) saturate(746%) hue-rotate(352deg) brightness(98%) contrast(103%);
}
.mobilenavbar-container .vs-button.active {
    transform: translateY(-1px);
}

/* Center action: subtle bounce on tap */
.mobilenavbar-container .vs-button.center-action {
    transition: transform .16s ease, box-shadow .25s ease;
}
.mobilenavbar-container .vs-button.center-action:active {
    transform: scale(.95);
}
</style>
